import React from "react";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSiteConfig } from "@/context/SiteConfigContext";

const KEYS = {
  pricing: "pricing_disclaimer",
  banking: "banking_approval_disclaimer",
  compliance: "compliance_disclaimer",
};

export default function Disclaimer({ type, className = "" }) {
  const { config } = useSiteConfig();
  const { t } = useTranslation();
  const configText = config?.[KEYS[type]];
  // English keeps the admin-editable config text; non-English uses an approved
  // translation when available, otherwise falls back to the config (English) text.
  const text = t(`disclaimer.${type}`, { defaultValue: configText || "" });
  if (!text) return null;
  return (
    <p
      className={`flex items-start gap-2 text-[11px] leading-relaxed text-muted-foreground/90 ${className}`}
      data-testid={`disclaimer-${type}`}
    >
      <Info className="h-3.5 w-3.5 mt-0.5 shrink-0 text-muted-foreground/70" />
      <span>{text}</span>
    </p>
  );
}
